export const decodeHtmlEntities = (input: string) => {
  const text = document.createElement('textarea')
  text.innerHTML = input
  return text.value
}

export const htmlToText = (html: string) => {
  const removedHtml = html.replace(/<[^>]+>/g, '')
  const cleanedText = removedHtml.replace(/[\n\r]/g, '')
  return cleanedText
}
